import { CLIENTS } from "../../data/site";

export const ClientsMarquee = () => (
  <section data-testid="clients-section" className="relative py-16 border-y border-sky-500/15 bg-[#060913] overflow-hidden">
    <p className="text-center font-mono2 text-xs uppercase tracking-[0.3em] text-slate-500 mb-10 px-4">
      Our Alumni & Trainers Work At
    </p>
    <div className="relative">
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#060913] to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#060913] to-transparent z-10" />
      <div className="flex w-max animate-marquee gap-0">
        {[...CLIENTS, ...CLIENTS].map((c, i) => (
          <span key={`${c}-${i}`} className="flex items-center shrink-0">
            <span className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-600 hover:text-sky-400 transition-colors duration-300 px-8 whitespace-nowrap">
              {c}
            </span>
            <span className="w-2 h-2 rounded-full bg-orange-500/60 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  </section>
);
